import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Text = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: block; ;
`;

const Bold = styled.div`
  font-weight: 500;
`;

const Accent = styled.span`
  color: #fcc475;
`;

const SoHandlingTooltipMixed = ({ className }) => {
  const { t } = useTranslation('Catalog');

  return (
    <div className={className}>
      <Text>
        <Bold>
          <Accent>{t('complements.handling_tooltip_mixed.line1')}</Accent>
        </Bold>
      </Text>
      <Text>{t('complements.handling_tooltip_mixed.line2')}</Text>
    </div>
  );
};

export default styled(SoHandlingTooltipMixed)`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 12px;
`;
